import { KeyboardEvent } from 'react';

export const handleKeyDown = (action: (() => void) | undefined) => (ev: KeyboardEvent) => {
	if (ev.key === 'Enter') {
		action?.();
		return;
	}
};
